<template>
  <footer align="left">
    <div class="top w-100">
      <b-row>
        <b-col cols="12" md="6" class="mb-3 mb-md-0">
          <b-row>
            <b-col cols="6" md="6" class="mb-3 mb-md-0">
              <a :href="`${mv_url}/`"  class="d-inline-block text-white font-weight-bold mb-3">Home</a>
              <ul class="list-unstyled">
                <li class="mb-2">
                  <a :href="`${mv_url}/about-us/`" class="text-white">About Us</a>
                </li>
                <li class="mb-2">
                  <a :href="`${mv_url}/musicians/`"  class="text-white">Musicians</a>
                </li>
                <li class="mb-2">
                  <a :href="`${mv_url_wp}/blog/`"  class="text-white">Blog</a>
                </li>
                <li class="mb-2">
                  <a :href="`/#/donation-page`"  class="text-white">Mission Projects</a>
                </li>
              </ul>
            </b-col>
            <b-col cols="6" md="6">
              <span class="d-inline-block font-weight-bold mb-3">Contact</span>
              <ul class="list-unstyled">
                <li class="mb-2">
                  <a href="mailto:info@musicverse.org" class="text-white"><img src="@/assets/mail-footer-icon.png" class="mr-3 footer-icon d-none d-sm-inline-block" />info@musicverse.org</a>
                </li>
                <li class="mb-2">
                  <a href="https://www.facebook.com/musicverse.org" class="text-white"><img src="@/assets/fb-footer-icon.png" class="mr-3 footer-icon  d-none d-sm-inline-block" />Facebook</a>
                </li>
                <li class="mb-2">
                  <a href="https://www.instagram.com/musicverseinternational/?hl=en" class="text-white"><img src="@/assets/ig-footer-icon.png" class="mr-3 footer-icon  d-none d-sm-inline-block" />Instagram</a>
                </li>
                <li class="mb-2">
                  <a href="https://twitter.com/MusicVerseIntl" class="text-white"><img src="@/assets/twitter-footer-icon.png" class="mr-3 footer-icon  d-none d-sm-inline-block" />Twitter</a>
                </li>
                <li class="mb-2">
                  <a href="https://www.youtube.com/channel/UCjRCshDsxtam7Wh9SIKLuHA" class="text-white"><img src="@/assets/yt-footer-icon.png" class="mr-3 footer-icon  d-none d-sm-inline-block" />Youtube</a>
                </li>
              </ul>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6" align="right">
          <b-row class="justify-content-center flex-column flex-sm-row justify-content-xl-end align-items-center">
            <a href="https://musicverse.onelink.me/vYmO/mainwebsite" class="mt-3 mt-sm-0 mr-0 mr-sm-3 footer-logo">
              <img src="@/assets/applestore-logo.png" class="footer-logo">
            </a>
            <a href="https://musicverse.onelink.me/vYmO/mainwebsite" class="mt-3 mt-sm-0 mr-0 mr-sm-3 footer-logo">
              <img src="@/assets/googleplay-logo.png" class="footer-logo">
            </a>
            <a href="https://musicverse.onelink.me/vYmO/mainwebsite" class="mt-3 mt-xl-0 footer-logo">
              <img src="@/assets/huawei-logo.png" class="footer-logo radius">
            </a>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="copyright w-100">
      <span>MusicVerse © 2021 All Rights Reserved Legal Info, <a style="color:#ffffff" href="https://musicverse.org/terms-and-conditions/">Terms of Use</a>, <a style="color:#ffffff" href="https://musicverse.org/privacy-policy/">Privacy Policy</a>. </span>
    </div>
  </footer>
</template>

<script>
const MV_URL = process.env.MUSICVERSE_URL;
const MV_URL_WP = process.env.MUSICVERSE_URL_WP;
export default {
  name: "FooterLanding",
  data: () => ({
    mv_url:MV_URL,
    mv_url_wp:MV_URL_WP,
  })
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FooterLanding.vue